module.exports = __webpack_public_path__ + "static/media/switch.6b4393cf.wav";